import createChannel from "admin/cable";

let receivedCallback, statusCallback;

const editor = createChannel({ channel: "EditorChannel", page_id: $('input[name$="page_id"]').val() }, {
  connected() {
    if (statusCallback) statusCallback.call(null, {status: "Connected", keep: false, error: false});
  },

  disconnected() {
    if (statusCallback) statusCallback.call(null, {status: "Disconnected", keep: true, error: true});
  },

  received(data) {
    if (statusCallback) statusCallback.call(null, {status: "Connected", keep: false, error: false});
    if (receivedCallback) receivedCallback.call(null, data);
  }
});

function refreshLock() {
  console.log(editor)
// debugger
  editor.perform("refresh_lock");
}

function takeOver() {
  editor.perform("take_over");
}

function save(data) {
  editor.perform("editor_save", data);
}

function setReceivedCallback(fn) {
  receivedCallback = fn;
}

function setStatusCallback(fn) {
  statusCallback = fn;
}

export { refreshLock, takeOver, save, setReceivedCallback, setStatusCallback };
